import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../../generic/FieldProps';
import { GenericInputField } from '../../../../../generic/GenericInputField';
import { BirthRegistryOfficeInput } from './BirthRegistryOfficeInput';

export function BirthRegistryOfficeField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={BirthRegistryOfficeInput}
      label='Vorname'
    />
  );
}
